<template>
  <div class="row">
    <work-menu></work-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_READ','ROLE_WORK_ADMIN')">
      <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
            <button type="button" class="btn btn-info m-1" data-toggle="modal" data-target="#default">新規登録</button>
        </div>
        <!-- New Modal -->
        <div class="modal fade" id="default" tabindex="-1" role="dialog" aria-labelledby="newShiftModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newShiftModal">新規登録</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-bod mt-3 p-5">
                        <form method="post" @submit.prevent="upsert(shift)">
                            <div class="form-group row">
                                <label class="col-2">シフト名</label>
                                <input type="text" class="col-10 form-control" v-model="shift.name" required="required"/>
                            </div>
                            <div class="form-group row">
                                <label class="col-2">開始時刻</label>
                                <select class="custom-select" v-model="shift.startHour">
                                    <option v-for="(startHour, index) in 24" :value="index" :key="startHour">
                                        {{index}}
                                    </option>
                                </select>
                                <span class="w-5 m-2">時</span>
                                <select class="custom-select" v-model="shift.startMin">
                                    <option v-for="(startMin, index) in 60" :value="index" :key="startMin">
                                        {{index}}
                                    </option>
                                </select>
                                <span class="w-5 m-2">分</span>
                            </div>
                            <div class="form-group row">
                                <label class="col-2">終了時刻</label>
                                <select class="custom-select" v-model="shift.endHour">
                                    <option v-for="(endHour, index) in 24" :value="index" :key="endHour">
                                        {{index}}
                                    </option>
                                </select>
                                <span class="w-5 m-2">時</span>
                                <select class="custom-select" v-model="shift.endMin">
                                    <option v-for="(endMin, index) in 60" :value="index" :key="endMin">
                                        {{index}}
                                    </option>
                                </select>
                                <span class="w-5 m-2">分</span>
                            </div>
                            <div class="form-group row">
                                <label class="col-2">休憩時間</label>
                                <select class="custom-select" v-model="shift.breakTimeHour">
                                    <option v-for="(breakTimeHour, index) in 24" :value="index" :key="breakTimeHour">
                                        {{index}}
                                    </option>
                                </select>
                                <span class="w-5 m-2">：</span>
                                <select class="custom-select" v-model="shift.breakTimeMinute">
                                    <option v-for="(breakTimeMinute, index) in 60" :value="index" :key="breakTimeMinute">
                                        {{index}}
                                    </option>
                                </select>
                            </div>
                            <button type="submit" class="btn btn-primary">追加</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <table class="table table-bordered table-responsive">
            <thead class="thead-light">
            <tr>
                <th>シフト名</th>
                <th>出勤時間</th>
                <th>退勤時間</th>
                <th>所定休憩時間</th>
                <th>作成日</th>
                <th>更新日</th>
                <th>編集</th>
                <th>削除</th>
            </tr>
            </thead>
            <tbody th:remove="all-but-first">
            <tr v-for="result in shiftList" :key="result.id">
                <td>{{result.name}}</td>
                <td>{{result.startHour}}:{{result.startMin | twoDigit}}</td>
                <td>{{result.endHour}}:{{result.endMin | twoDigit}}</td>
                <td>{{result.breakTimeHour}}:{{result.breakTimeMinute | twoDigit}}</td>
                <td>{{result.createdDate | datetime}}</td>
                <td>{{result.modifiedDate | datetime}}</td>

                <!-- 編集 -->
                <td>
                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
                        <button class="btn btn-raised btn-outline-info btn-sm" data-toggle="modal" :data-target="'#' + result.id">
                            <i class="fa fa-edit"></i>編集
                        </button>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" :id="result.id" tabindex="-1" role="dialog" aria-labelledby="updateModal" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="updateModal">編集</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="modal-body mt-3 p-5">
                                    <form method="post" @submit.prevent="upsert(result)">
                                        <div class="form-group row">
                                            <label class="col-2">シフト名</label>
                                            <input type="text" class="col-10 form-control" name="name" v-model="result.name" required="required"/>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-2">開始時刻</label>
                                            <select class="custom-select" name="startHour" v-model="result.startHour">
                                                <option v-for="(startHour, index) in 24" :value="index" :key="startHour">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">時</span>
                                            <select class="custom-select" name="startMin" v-model="result.startMin">
                                                <option v-for="(startMin, index) in 60" :value="index" :key="startMin">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">分</span>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-2">終了時刻</label>
                                            <select class="custom-select" name="endHour" v-model="result.endHour">
                                                <option v-for="(endHour, index) in 24" :value="index" :key="endHour">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">時</span>
                                            <select class="custom-select" name="endMin" v-model="result.endMin">
                                                <option v-for="(endMin, index) in 60" :value="index" :key="endMin">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">分</span>
                                        </div>
                                        <div class="form-group row">
                                            <label class="col-2">休憩時間</label>
                                            <select class="custom-select" name="breakTimeHour" v-model="result.breakTimeHour">
                                                <option v-for="(breakTimeHour, index) in 24" :value="index" :key="breakTimeHour">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">時</span>
                                            <select class="custom-select" name="breakTimeMinute" v-model="result.breakTimeMinute">
                                                <option v-for="(breakTimeMinute, index) in 60" :value="index" :key="breakTimeMinute">
                                                    {{index}}
                                                </option>
                                            </select>
                                            <span class="w-5 m-2">分</span>
                                        </div>
                                        <button type="submit" class="btn btn-raised btn-primary">編集</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
                <!-- 削除 -->
                <td>
                    <div v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_ADMIN')">
                        <button type="button" class="btn btn-outline-danger btn-sm" data-toggle="modal" :data-target="'#delete' + result.id">
                            <i class="fa fa-trash" aria-hidden="true"></i>
                            削除
                        </button>
                    </div>
                    <!-- Modal -->
                    <div class="modal fade" :id="'delete' + result.id" tabindex="-1"
                         role="dialog" aria-labelledby="deleteModal" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title" id="deleteModal">確認</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    シフト名
                                    <p>{{result.name}}</p>
                                    出勤時間
                                    <p>{{result.startHour}}:{{result.startMin,2}}</p>
                                    退勤時間
                                    <p>{{result.endHour}}:{{result.endMin}}</p>
                                    <p class="text-danger">ユーザに設定されているシフトは設定なしになります。本当によろしいですか？</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">キャンセル</button>
                                    <button type="button" class="btn btn-danger" @click="deleteShift(result.id)">削除</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import ShiftAPI from '../../../api/shift-api'
import CommonAPI from '../../../api/common-api'
import moment from 'moment'
import WorkMenu from './WorkMenu.vue'

export default {
  name: "work-shift-manage",
  components: {
    WorkMenu,
  },
  data() {
    return {
      loginUser: {
        role: ''
      },
      shift: {
          startHour: 0,
          startMin: 0,
          endHour: 0,
          endMin: 0,
          breakTimeHour: 0,
          breakTimeMinute: 0
      },
      shiftList: []
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = val
    },
  },
  mounted () {
    this.getShiftList()
  },
  methods: {
    // シフト一覧取得
    getShiftList () {
      $(".close").click()
      this.$root.$refs.loading.$data.show = true
      ShiftAPI.getShiftList()
        .then(res => {
            this.shiftList = res
            this.$root.$refs.loading.$data.show = false
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // シフト更新
    upsert (data) {
      this.$root.$refs.loading.$data.show = true
      this.shift.companyId = this.loginUser.companyId
      ShiftAPI.upsert(data)
        .then(res => {
            this.getShiftList()
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // シフト削除
    deleteShift (id) {
      this.$root.$refs.loading.$data.show = true
      ShiftAPI.delete(id)
        .then(res => {
            this.getShiftList()
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    }
  },
  filters: {
    datetime: function (data) {
      return moment(data).format('YYYY年MM月DD日 HH:mm')
    },
    // 2桁0埋め
    twoDigit: function (data) {
        return ("0" + data).slice(-2)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/work/WorkShiftManage.vue